import React, {Component} from 'react'
import {Query} from '@apollo/client/react/components'
import PropTypes from 'prop-types'
import LogService from '../rate-gql/services/log-service'
import {DATES_QUERY} from './graphql/queries/dates'
import * as packageJson from '../package.json'
// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
import withCacheClient from '@cred/shared/hoc/withCacheClient'
import ComponentTag from '@cred/react-component-tag'


const months = [
  'January', 'February', 'March',
  'April', 'May', 'June', 'July',
  'August', 'September', 'October',
  'November', 'December'
]

class DateGQL extends Component {
  static propTypes = {
    rateType: PropTypes.string.isRequired,
    vertical: PropTypes.string,
    lenderSlug: PropTypes.string,
    term: PropTypes.number,
    variable: PropTypes.bool,
    name: PropTypes.string,
    format: PropTypes.func,
    componentTag: PropTypes.object
  }

  static defaultProps = {
    rateType: 'index',
    term: null,
    variable: null,
    name: 'LIBOR',
    format: null,
    componentTag: null
  }

  queryHandler = format => ({loading, error, data}) => {
    const {className, componentTag} = this.props

    if (error) {
      LogService.error(`[Rates] Error getting a rate: ${error}`)

      return null
    }

    if (loading) {
      return null
    }

    return <span className={className} {...componentTag}>{this.getDateValue(data, format)}</span>
  }

  getDateValue(data, format) {
    const rawValue = this.getDateRawValue(data)

    if (rawValue) {
      let date = rawValue.split(' ')[0],
        dateArr = date.split('-')

      if (format) {
        return format(dateArr, months)
      } else {
        return `${months[parseInt(dateArr[1]) - 1]} ${parseInt(dateArr[2])}, ${dateArr[0]}`
      }
    } else {
      return null
    }
  }

  getDateRawValue(data) {
    if (data && data.searchRates && data.searchRates[0]) {
      return data.searchRates[0].publishedFrom
    }
  }

  render() {
    const {rateType, vertical, lenderSlug, term, variable, name, format} = this.props,
      args = {rateType, vertical, lenderSlug, term, variable, name}

    return (
      <Query query={DATES_QUERY} variables={{args, published: true}}>
        {this.queryHandler(format)}
      </Query>
    )
  }
}

export {DateGQL}

export default /*#__PURE__*/ ComponentTag(packageJson)(withCacheClient(DateGQL))
